import React, { useState } from "react";
import { useGetuploadCsvMutation } from "./sql/TablesourceApiSlice";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import { useGetLatestDraftQuery } from "./sql/sqlApiSlice";
import { useNavigate } from "react-router-dom";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import UploadCSV from "./UploadCSV";
import useAuth from "../../hooks/useAuth";
export default function NewDataSources({ setShowPopup }) {
  const [showExcelPopup, setShowExcelPopup] = useState(false);
  const [showCSVModal, setCSVModal] = useState(false);
  const [file, setFile] = useState(null);
  const [FileName, setFileName] = useState("");
  const navigate = useNavigate();
  const { username } = useAuth();
  const [getuploadCsv, { isLoading, isSuccess, isError, error }] =
    useGetuploadCsvMutation();
  //latsetdraft

  const {
    data: draftData,
    isLoading: isDraftLoading,
    isError: isDraftError,
    error: draftError,
    isSuccess: isDraftSuccess,
  } = useGetLatestDraftQuery();
  console.log(draftData);
  const dataSources = [
    // { name: "Excel file", image: "/images/MSExcel.png" },
    { name: "CSV", image: "/images/csvImage.png" },
    { name: "MySQL", image: "/images/MYSql.png" },
  ];

  // const serverSources = [{ name: "MySQL", image: "/images/MYSql.png" }];

  const DataSourceItem = ({ source, onClick }) => (
    <button
      className="flex flex-col w-28 h-hull justify-start items-center cursor-pointer shadow-md hover:shadow-lg transition-shadow duration-200"
      onClick={onClick}
    >
      <img
        src={source.image}
        className="w-full h-auto rounded"
        alt={source.name}
      />
      <span className="bg-gray-100 text-black w-full rounded p-1 pt-0 text-center text-sm font-medium">
        {source.name}
      </span>
    </button>
  );

  const handleUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      console.log(formData);

      try {
        await getuploadCsv({
          formData,
        }).unwrap();
        setFile(null);
        setFileName("");
        setTimeout(() => {
          setShowExcelPopup(false);
        }, 1000);
      } catch (error) {
        console.error("Upload failed:", error);
      }
    }
  };

  const ExcelFilePopup = ({ onClose }) => {
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      console.log(file);
      if (file) {
        setFile(file);
        setFileName(file.name);
      }
    };
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "Enter") {
        handleUpload(); // Call your function here
      }
    }

    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50"  onKeyDown={handleKeyDown}>
        <div className="bg-white p-6 rounded-lg shadow-xl w-[90%] max-w-lg transition-transform transform scale-100">
          <h2 className="text-xl font-medium text-gray-800 mb-4">
            Upload Excel File
          </h2>
          <input
            type="file"
            onChange={handleFileChange}
            accept=".csv"
            className="mb-4 border border-gray-300 p-2 rounded w-full text-sm"
          />
          {FileName && (
            <p className="mb-4 text-sm text-gray-600">
              Selected file:{" "}
              <strong className="text-blue-500">{FileName}</strong>
            </p>
          )}
          <div className="flex justify-end gap-4">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-blue-950 text-white rounded hover:bg-blue-700 transition-colors disabled:bg-gray-400"
              onClick={handleUpload}
              disabled={isLoading}
            >
              Upload CSV file
            </button>
          </div>

          {isLoading && <LoadingIndicator />}
          {isSuccess && (
            <div className="text-green-600 mt-4">
              File uploaded successfully!
            </div>
          )}
          {isError && (
            <div className="text-red-600 mt-4">
              Error uploading file:{" "}
              {typeof error?.data === "string"
                ? error.data
                : JSON.stringify(error?.data)}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {showExcelPopup && (
        <ExcelFilePopup onClose={() => setShowExcelPopup(false)} />
      )}
      <section className="border-t-4 border-blue-950 w-full px-[1.9%] flex h-[25%] gap-2">
        {/* left side */}
        <div className="w-[51%] flex flex-col h-full overflow-hidden gap-2">
          <h1 className="w-full text-left tracking-wide font-medium">
            New Datasources
          </h1>
          <div className="w-full gap-2 justify-start items-center flex h-[95%] overflow-hidden overflow-x-auto">
            {dataSources.map((source, index) => (
              <DataSourceItem
                key={index}
                source={source}
                onClick={() => {
                  if (source.name === "Excel file") {
                    setShowExcelPopup(true);
                  }
                  if (source.name === "MySQL") {
                    setShowPopup(true);
                  }
                  if (source.name === "CSV") {
                    setCSVModal(true);
                  }
                }}
              />
            ))}
          </div>
        </div>
        <div className="border w-[2px] h-[98%] items-center relative top-[1%]"></div>
        {/* right side */}
        <div className="flex flex-col h-full overflow-hidden w-[40%] items-start justify-start">
          <h1 className="w-full text-left tracking-wide font-medium flex flex-col items-start justify-start">
            Recent Drafts
          </h1>
          <table className={`w-full border rounded flex flex-col h-[85%]`}>
            <thead className="flex items-center justify-start px-2 bg-gray-200  text-gray-800 border-b text-[15px]">
              <th className="flex gap-2 items-center justify-start w-1/2">
                <MdOutlineDriveFileRenameOutline />
                Name
              </th>
              <th className="flex gap-2 items-center justify-start w-1/2 border-l border-gray-300">
                <MdOutlineAccessTimeFilled />
                Create On
              </th>
            </thead>
            <tbody className="overflow-auto px-[0.6rem] pt-1 w-full">
              {Array.isArray(draftData) &&
                draftData
                  .filter((dItem) => dItem.createdBy === username)
                  .map((draftItem, index) => {
                    if ([0, 1, 2, 3, 4].includes(index)) {
                      return (
                        <tr
                          key={index}
                          className={`cursor-pointer flex w-full justify-between rounded text-gray-600 text-[15px] ${
                            index % 2 === 0 ? "bg-none" : "bg-gray-200"
                          }`}
                          onClick={() =>
                            navigate(`/workbook?workbookid=${draftItem._id}`)
                          }
                        >
                          <td className="w-1/2 flex items-center justify-normal">
                            {" "}
                            {draftItem.name}
                          </td>
                          <td className="w-1/2 pl-[0.1rem] flex items-center justify-normal">
                            {new Date(draftItem.createdOn).toLocaleString()}
                          </td>
                        </tr>
                      );
                    }
                  })}
            </tbody>
          </table>
        </div>
      </section>
      {showCSVModal ? (
        <UploadCSV closeModal={() => setCSVModal(false)} />
      ) : null}
    </>
  );
}
